export const ru = {
  app: {
    title: "Цифровые двойники",
    subtitle: "Интервью",
    logout: "Выйти",
    settings: "Настройки аккаунта",
  },
  auth: {
    login: "Войти",
    register: "Зарегистрироваться",
    email: "Электронная почта",
    password: "Пароль",
    haveAccount: "Уже есть аккаунт?",
    needAccount: "Нет аккаунта?",
    submitting: "Отправка…",
    invalidCredentials: "Неверная почта или пароль",
    unknownError: "Не удалось связаться с сервером",
    notVerified: "Подтвердите аккаунт, чтобы продолжить",
  },
  register: {
    title: "Регистрация",
    subtitle: "Создайте аккаунт, чтобы пройти интервью и получить своего цифрового двойника.",
    firstName: "Имя",
    firstNameHint: "Необязательно — как к вам обращаться.",
    passwordHint: "Не менее 8 символов.",
    channelTitle: "Куда отправлять подтверждение и напоминания",
    channelEmail: "На электронную почту",
    channelTelegram: "В Telegram",
    channelHint:
      "Через этот канал мы подтвердим аккаунт и будем присылать напоминания о повторном анкетировании.",
    phone: "Номер телефона",
    phonePlaceholder: "+7 ___ ___-__-__",
    phoneHint: "Нужен для связи через Telegram.",
    submit: "Зарегистрироваться",
    emailTaken: "Эта почта уже зарегистрирована — попробуйте войти.",
    emailInvalid: "Электронная почта указана в неверном формате.",
    passwordShort: "Пароль слишком короткий — нужно минимум 8 символов.",
    phoneRequired: "Для подтверждения через Telegram укажите номер телефона.",
    error: "Не удалось завершить регистрацию",
  },
  verify: {
    title: "Подтверждение аккаунта",
    subtitleEmail: "Мы отправили письмо с кодом подтверждения на вашу почту.",
    subtitleTelegram: "Подтвердите аккаунт через Telegram.",
    enterCode: "Введите код из письма",
    enterCodeTelegram: "Введите код из Telegram",
    codePlaceholder: "Код из 6 цифр",
    confirm: "Подтвердить",
    resend: "Отправить код повторно",
    resendCooldown: "Отправить код повторно (через {{seconds}} с)",
    resent: "Код отправлен повторно",
    orLink: "…или просто перейдите по ссылке из письма — страница обновится автоматически.",
    telegramOpen: "Открыть Telegram",
    telegramQr: "Или отсканируйте QR-код, чтобы открыть бота:",
    telegramSteps:
      "Откройте бота по ссылке или QR-коду и нажмите «Старт» — бот пришлёт код подтверждения.",
    waiting: "Ожидаем подтверждения…",
    success: "Аккаунт подтверждён",
    successHint: "Теперь войдите в систему заново.",
    toLogin: "Войти",
    badCode: "Неверный код. Проверьте и попробуйте ещё раз.",
    tooMany: "Слишком много попыток. Запросите новый код.",
    expired: "Срок действия кода истёк. Запросите новый.",
  },
  mfa: {
    title: "Подтверждение входа",
    subtitleEmail: "Мы отправили код подтверждения на вашу почту.",
    subtitleTelegram: "Мы отправили код подтверждения в Telegram.",
    enterCode: "Введите код подтверждения",
    codePlaceholder: "Код из 6 цифр",
    confirm: "Войти",
    trustDevice: "Доверять этому устройству 30 дней",
    trustHint: "На доверенном устройстве код больше не потребуется.",
    orLink: "…или перейдите по ссылке из сообщения — вход произойдёт автоматически.",
    badCode: "Неверный код. Проверьте и попробуйте ещё раз.",
    tooMany: "Слишком много попыток. Войдите заново, чтобы получить новый код.",
    expired: "Срок действия кода истёк. Войдите заново.",
  },
  settings: {
    title: "Настройки аккаунта",
    email: "Электронная почта",
    emailReadonly: "Почта используется для входа и не меняется.",
    channelTitle: "Канал уведомлений",
    channelEmail: "Электронная почта",
    channelTelegram: "Telegram",
    channelHint: "Сюда приходят напоминания о повторном анкетировании.",
    phone: "Номер телефона",
    phonePlaceholder: "+7 ___ ___-__-__",
    save: "Сохранить",
    saved: "Сохранено",
    reverifyNote: "При смене канала потребуется заново подтвердить аккаунт.",
    reverify: "Подтвердить заново",
    verified: "Аккаунт подтверждён",
    notVerified: "Аккаунт не подтверждён",
    error: "Не удалось сохранить изменения",
  },
  consent: {
    title: "Правила участия в исследовании",
    intro:
      "Добро пожаловать! Это интервью поможет создать вашего персонального цифрового двойника — модель, которая отражает ваши взгляды, интересы и манеру речи.",
    rulesTitle: "Перед началом ознакомьтесь с правилами:",
    rule1: "Интервью состоит из открытых вопросов о вас, ваших взглядах, интересах и привычках.",
    rule2: "Отвечайте искренне и своими словами — правильных или неправильных ответов нет.",
    rule3:
      "Отвечать можно текстом или голосом, в любом удобном темпе: прогресс сохраняется, вы можете прерваться и вернуться позже.",
    rule4:
      "Ваши ответы хранятся в обезличенном виде и используются только для создания вашего двойника.",
    rule5: "Участие в исследовании разрешается только совершеннолетним (18+).",
    rule6: "Участие в исследовании доступно только гражданам России.",
    checkRules: "Ознакомился (-лась) с правилами проведения исследования и принимаю их",
    checkNotifications:
      "Соглашаюсь получать уведомления на электронную почту и/или в мессенджер, в том числе уведомления о повторном анкетировании",
    continue: "Продолжить",
  },
  interview: {
    start: "Начать интервью",
    resume: "Продолжить интервью",
    progress: "Прогресс",
    answered: "Отвечено",
    yourAnswer: "Ваш ответ",
    savedAnswer: "Ранее сохранённый ответ",
    sendAnswer: "Отправить ответ",
    voice: "Ответить голосом",
    prev: "Предыдущий вопрос",
    nextQuestion: "Следующий вопрос",
    jump: "Перейти к номеру",
    rewrite: "Перезаписать ответ",
    detailNote: "Как отвечать",
  },
};

export type Translations = typeof ru;
